package com.daytimegaming.ourdailyfinances.data.network.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ServerEventDto(
    @SerialName("type") val type: String,
    @SerialName("event") val event: String,
    @SerialName("dashboard_id") val dashboardId: String? = null,
    @SerialName("account_id") val accountId: String? = null,
)
